import React, {useEffect, useState} from "react";
import {Text} from '@consta/uikit/Text';
import {Button} from '@consta/uikit/Button';
import {IconLineAndBarChart} from "@consta/uikit/IconLineAndBarChart";
import ReportToExcel from "./component/export.report.func";
import moment from "moment";
import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {API_REPORTS_EVENT} from "../../service/api.endpoint";
import {IconEye} from "@consta/uikit/IconEye";
import "./component/css/css.page.report.css";

const PageReport = () => {
    const [valueRep1, setValueRep1] = useState<Date | undefined>(new Date());
    const [rep1Loading, setRep1Loading] = useState<boolean>(false)
    const [dataReport1, setDataReport1] = useState<any>([])
    const [reportProgress, setReportProgress] = useState<any>(null)

    useEffect(() => {
        document.title = 'АСПО.Контроль | Отчеты';
    }, []);

    const {isPending, refetch} = useQuery({
        queryKey: ['reportEvevntData'],
        queryFn: async () => {
            return await axios.get(API_REPORTS_EVENT, {params: {name: 'Report1'}}).then(
                (res) => {
                    setDataReport1([])
                    res.data.forEach((el: any) => {
                        const date = moment(el['date'], 'DD.MM.YYYY').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]')
                        setDataReport1((prevState: any) => [...prevState, {
                            report_date: el['date'],
                            date: moment(date).toDate(),
                            updated_at: el['updated_at']
                        }]);
                    })
                    return res.data
                },
            )
        },
    })

    const reportRows = [...dataReport1].sort((a: any, b: any) => (
        new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime()
    ));
    const latestReport = reportRows[0]
    const selectedReportDate = moment(valueRep1 || new Date()).format('DD.MM.YYYY')
    const selectedReport = reportRows.find((item: any) => item.report_date === selectedReportDate)

    const openReport = async (reportMeta: any) => {
        if (!reportMeta?.report_date) {
            return
        }
        setRep1Loading(true)
        setReportProgress(null)
        try {
            const response = await axios.get(API_REPORTS_EVENT, {
                params: {
                    name: 'Report1',
                    date: reportMeta.report_date,
                    includeData: 'true'
                }
            })
            const report = response.data?.[0]
            if (report) {
                const payload = {
                    date: new Date(reportMeta.date).getTime(),
                    data: JSON.parse(JSON.stringify(report.data)),
                    updated_at: report.updated_at
                }
                ReportToExcel(reportMeta.report_date, setRep1Loading, payload)
            } else {
                setRep1Loading(false)
            }
        } catch (e) {
            setRep1Loading(false)
        }
    }

    const handleReportClick = async () => {
        setRep1Loading(true)
        setReportProgress({
            status: 'QUEUED',
            progress: 0,
            message: 'Ставлю отчет в очередь'
        })
        try {
            await ReportToExcel(selectedReportDate, setRep1Loading, undefined, {
                onProgress: (progress: any) => {
                    setReportProgress(progress)
                }
            })
            refetch()
        } catch (e) {
            setRep1Loading(false)
        }
    }

    const handleDateChange = (value: string) => {
        const nextDate = value ? moment(value, 'YYYY-MM-DD').toDate() : undefined
        setValueRep1(nextDate)
    }

    return (
        <div className="reports-page">
            <section className="report-panel">
                <div className="report-main">
                    <div>
                        <Text size="l" weight="bold">Отчеты</Text>
                        {latestReport
                            ? <Text size="s" view="secondary">
                                Последний готовый: {latestReport.report_date}, сформирован {moment(latestReport.updated_at).add(5, 'hours').format('DD.MM.YYYY HH:mm')}
                            </Text>
                            : <Text size="s" view="secondary">Готовых отчетов пока нет</Text>}
                    </div>
                    <div className="report-actions">
                        <input
                            className="report-date-input"
                            type="date"
                            value={moment(valueRep1 || new Date()).format('YYYY-MM-DD')}
                            onChange={(event) => handleDateChange(event.target.value)}
                        />
                        <Button
                            label="Открыть готовый"
                            view="secondary"
                            size="s"
                            iconLeft={IconEye}
                            disabled={!selectedReport || rep1Loading || isPending}
                            onClick={() => openReport(selectedReport)}
                        />
                        <Button
                            label="Сформировать"
                            view="primary"
                            size="s"
                            iconLeft={IconLineAndBarChart}
                            disabled={rep1Loading}
                            onClick={handleReportClick}
                        />
                        <Button label="Обновить" view="clear" size="s" onClick={() => refetch()}/>
                    </div>
                </div>

                {rep1Loading && <div className="report-progress">
                    <div className="report-progress-top">
                        <Text size="s" weight="bold">{reportProgress?.message || 'Формирую отчет'}</Text>
                        <Text size="s" view="secondary">{Math.round(reportProgress?.progress || 0)}%</Text>
                    </div>
                    <div className="report-progress-track">
                        <div
                            className="report-progress-fill"
                            style={{width: `${Math.min(100, Math.max(0, reportProgress?.progress || 0))}%`}}
                        />
                    </div>
                </div>}
            </section>
        </div>
    );
}

export default PageReport;
